var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-header-root" },
    [
      _c("div", { staticClass: "head_bg" }, [
        _c(
          "header",
          {
            staticClass: "head_warp showSlide",
            class: { deyuHeader: _vm.$route.path === "/deYu" },
            on: {
              mouseleave: function ($event) {
                _vm.showMenu = false
              },
            },
          },
          [
            _c("div", { staticClass: "head_body" }, [
              _c(
                "div",
                {
                  staticClass: "head_title flex_center",
                  on: { click: _vm.goHome },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/newimg/logo.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "head_nav" }),
              _vm._v(" "),
              _vm.showHeaderSearch
                ? _c("div", { staticClass: "head_search_group" }, [
                    _c(
                      "div",
                      { staticClass: "head_wbox head_search_new" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "head_search_type",
                            attrs: { "popper-append-to-body": true },
                            on: { change: _vm.handleSearchTypeChange },
                            model: {
                              value: _vm.searchType,
                              callback: function ($$v) {
                                _vm.searchType = $$v
                              },
                              expression: "searchType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "关键字检索", value: "keyword" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "语义检索", value: "semantic" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "head_search_divider" }),
                        _vm._v(" "),
                        _c(
                          "el-input",
                          {
                            attrs: { placeholder: _vm.searchPlaceholder },
                            on: {
                              focus: _vm.showHistoryPanel,
                              blur: _vm.hideHistoryPanel,
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearch($event)
                              },
                            },
                            model: {
                              value: _vm.searchState,
                              callback: function ($$v) {
                                _vm.searchState = $$v
                              },
                              expression: "searchState",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "head_search_logo",
                              attrs: {
                                slot: "suffix",
                                src: require("@/assets/newimg/home_search.png"),
                                alt: "",
                              },
                              on: { click: _vm.handleSearch },
                              slot: "suffix",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.showHistory &&
                                  _vm.searchType === "keyword",
                                expression:
                                  "showHistory && searchType === 'keyword'",
                              },
                            ],
                            staticClass: "search_history_box",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "search_history_list" },
                              _vm._l(_vm.searchHistoryList, function (item) {
                                return _c(
                                  "span",
                                  {
                                    key: item,
                                    staticClass: "search_history_item",
                                    on: {
                                      mousedown: function ($event) {
                                        $event.preventDefault()
                                        return _vm.handleHistorySearch(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "head_home_btn", on: { click: _vm.goHome } },
                [
                  _c("i", { staticClass: "el-icon-house" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("首页")]),
                ]
              ),
              _vm._v(" "),
              !_vm.userInfo.userName
                ? _c(
                    "div",
                    {
                      staticClass: "head_wbox head_bnts",
                      on: { click: _vm.toLogin },
                    },
                    [_vm._v("\n        登录\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userInfo.userName
                ? _c(
                    "div",
                    [
                      _c(
                        "el-dropdown",
                        [
                          _c("span", { staticClass: "el-dropdown-link" }, [
                            _c("img", {
                              staticClass: "top-bar__img",
                              attrs: { src: _vm.userLogin.userHd },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.userInfo.userName) +
                                "\n            "
                            ),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right",
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c("el-dropdown-item", [
                                _c("div", { on: { click: _vm.toAdmin } }, [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-li" },
                                    [_vm._v("个人中心")]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: { divided: "" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.logoutToPortal($event)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-li" },
                                    [_vm._v("退出")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("toLogin", { ref: "toLogin" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }